import { render, staticRenderFns } from "./NewDeviationMain.vue?vue&type=template&id=0055a376&scoped=true&"
import script from "./NewDeviationMain.vue?vue&type=script&lang=js&"
export * from "./NewDeviationMain.vue?vue&type=script&lang=js&"
import style0 from "./NewDeviationMain.vue?vue&type=style&index=0&id=0055a376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0055a376",
  null
  
)

/* custom blocks */
import block0 from "./NewDeviationMain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports